import React, { useEffect, useRef, useState } from 'react'
import signInPhone from '../../../assets/images/nexa-signin-phone.png'
import sureCarePhone from '../../../assets/images/nexa-surecare-phone.png'

const Main = ({dark}) => {
  const phoneStageRef = useRef(null)
  const [phonesVisible, setPhonesVisible] = useState(false)

  useEffect(() => {
    const stage = phoneStageRef.current
    if (!stage) return undefined

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setPhonesVisible(true)
        observer.disconnect()
      }
    }, { threshold: 0.28 })

    observer.observe(stage)
    return () => observer.disconnect()
  }, [])

  return (
    <>
        <section className="row_am about_app_section">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="about_img" data-aos="fade-in" data-aos-duration="1500">
                        <div ref={phoneStageRef} className={`about_phone_pair${phonesVisible ? ' phones-visible' : ''}`}>
                            <div className="about_phone_crop about_phone_signin">
                                <img className="about_phone" src={signInPhone} alt="Nexa sign-in screen in an iPhone frame" />
                            </div>
                            <div className="about_phone_crop about_phone_surecare">
                                <img className="about_phone" src={sureCarePhone} alt="Nexa SureCare product screen in an iPhone frame" />
                            </div>
                        </div>
                        </div>
                    </div>                   
                    <div className="col-lg-6">
                        <div className="about_text">
                        <div className="section_title" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="100">
                            <h2>Meet NEXA <span>— the future of protection.</span></h2>
                            <p>
                            Get confidence and convenience in one place. Imagine a seamless digital experience where insurance coverage becomes effortless, yet more powerful than ever before. Our app is meticulously crafted to cater to your unique needs, ensuring every aspect of your life remains secure, both now and in the times to come.
                            </p>
                        </div>
                        {dark &&
                            <ul className="list">
                                <li data-aos="fade-up" data-aos-duration="1500">
                                    <i className="icofont-verification-check"></i> Simply dummy text of the printing and 
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1500">
                                <i className="icofont-verification-check"></i> Typesetting industry lorem Ipsum has been the 
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1500">
                                    <i className="icofont-verification-check"></i> Industrys standard dummy text 
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1500">
                                    <i className="icofont-verification-check"></i> Simply dummy text of the printing and 
                                </li>
                                <li data-aos="fade-up" data-aos-duration="1500">
                                    <i className="icofont-verification-check"></i> Typesetting industry lorem Ipsum has been the 
                                </li>
                             </ul>}
                        </div>
                    </div>
                </div>
            </div>
        </section> 
    </>
  )
}

export default Main
